import { render } from "./MBreadcrumb.vue?vue&type=template&id=04df7c58&scoped=true"
import script from "./MBreadcrumb.vue?vue&type=script&lang=js"
export * from "./MBreadcrumb.vue?vue&type=script&lang=js"

import "./MBreadcrumb.vue?vue&type=style&index=0&id=04df7c58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04df7c58"]])

export default __exports__